import { Datagrid, List, TextField } from "react-admin";

// const Aside = () => (
//   <div style={{ width: 200, margin: "1em" }}>
//     <h3>123</h3>
//   </div>
// );

export const PharmacyList = (props) => {
  return (
    <List
      {...props}
      exporter={false}
      // aside={<Aside />}
    >
      <Datagrid rowClick="show">
        <TextField source="name" />
        <TextField source="vicinity" />
      </Datagrid>
    </List>
  );
};
